import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SwPush } from '@angular/service-worker';
import { environment } from 'src/environments/enviroments';

@Injectable({
  providedIn: 'root'
})
export class PushNotificationService {

  readonly VAPID_PUBLIC_KEY = "BLBx-hf2WrL2qEa0qKb-aCJbcxEvyn62GDTyyP9KTS5K7ZL0K7TfmOKSPqp8vQF0DaG8hpSBknz_x3qf5F4iEFo";
  constructor(private http: HttpClient, private swPush: SwPush) { }

  async hasActiveSubscription() {
    try{
      navigator.serviceWorker.ready.then(registration => {
        registration.pushManager.getSubscription().then(
          (subscription) => {
            if (subscription == null) {
              return false;
            }
            else {
              return true;
            }
          },
          onrejected => {
            return false;
      });
    });
    }
    catch(e){
      return false;
    }
    finally{
      return false;
    }
  }
  async subscribeToPush() {

    navigator.serviceWorker.ready.then(registration => {
      // registration.active.postMessage({ type: 'subscribe' });
      registration.pushManager.getSubscription().then(
        (subscription) => {
          if (subscription == null) {
            registration.pushManager.subscribe({
              userVisibleOnly: true,
              applicationServerKey: this.VAPID_PUBLIC_KEY,
            }).then(subscription => {
              console.log('User is subscribed:', subscription.toJSON());
              const endpoint = `${environment.apiUrl}/Notification/RegisterClient`;
              console.log(endpoint);
              let request = {
                "notificationClientId": 0,
                "site": "app.inge.cl",
                "endpoint": subscription.endpoint,
                "auth": subscription.toJSON().keys['auth'],
                "p256dh": subscription.toJSON().keys['p256dh']
              }
              this.http.post<any>(endpoint, request).subscribe(
                x => { console.log(x) }
              );
            });
          }
          else {
            console.log('User is already subscribed');
            // subscription.unsubscribe().then(() => {
            //   console.log('User is unsubscribed');
            //   const endpoint = `${environment.apiUrl}/Notification/UnregisterClient`;
            //   console.log(endpoint);
            //   let request = {
            //     "endpoint": subscription.endpoint
            //   }
            //   return this.http.post<any>(endpoint, request);
            // });
          }
        },
        onrejected => {
          console.log('Subscription has a problem');
        }
      )
    });
  }

  async unsuscribeToPush() {
    navigator.serviceWorker.ready.then(registration => {
      // registration.active.postMessage({ type: 'unsubscribe' });
      registration.pushManager.getSubscription().then(subscription => {
        if (subscription == null) {
          console.log('User is not subscribed');
        }
        else {
          subscription.unsubscribe().then(() => {
            console.log('User is unsubscribed');
            const endpoint = `${environment.apiUrl}/Notification/UnregisterClient`;
            console.log(endpoint);
            let request = {
              "endpoint": subscription.endpoint
            }
            return this.http.post<any>(endpoint, request);
          });
        }
      });
    });
  }
}
